import { Helmet } from 'react-helmet';
import Youtube from '../Components/Logics/Youtube';
import { lazy, Suspense } from 'react';
import { Col, Container } from 'react-bootstrap';
import WebsiteCover from '../Components/Logics/WebsiteCover';
import Styles from './HomeLayout.module.css';

// Keep below-fold Motion/grade initialization outside the hero's initial bundle.
const MainHome = lazy(() => import('../Components/Logics/MainHome'));

export default function HomePage() {
  return (
    <>
      <WebsiteCover />
      <article>
        <svg className={Styles.waves} xmlns="http://www.w3.org/2000/svg" viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
          <defs>
            <linearGradient id="waveGradient1" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="rgba(99,102,241,0.12)" />
              <stop offset="50%" stopColor="rgba(139,92,246,0.08)" />
              <stop offset="100%" stopColor="rgba(6,182,212,0.12)" />
            </linearGradient>
            <linearGradient id="waveGradient2" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="rgba(99,102,241,0.08)" />
              <stop offset="100%" stopColor="rgba(139,92,246,0.06)" />
            </linearGradient>
            <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
          </defs>
          <g className={Styles.parallax}>
            <use href="#gentle-wave" x="48" y="0" fill="url(#waveGradient1)" />
            <use href="#gentle-wave" x="48" y="3" fill="url(#waveGradient2)" />
            <use href="#gentle-wave" x="48" y="5" fill="rgba(99, 102, 241, 0.04)" />
            <use href="#gentle-wave" x="48" y="7" fill="rgba(255, 255, 255, 0.95)" />
          </g>
        </svg>
      </article>
      <Col xs={12}>
        <Helmet>
          <title>محمد يوسف - رياضيات</title>
          <meta
            name="description"
            content="تصفح كورسات اونلاين رياضيات المتاحة ثانوية عامة على منصة تعليمية اونلاين رياضيات"
          />
          <meta name="keywords" content="اولي ثانوي,تانيه ثانوي,تالته ثانوي,إحصاء,احصاء,رياضيات, كورسات, تعليم, منصة تعليمية ,ثانوية عامة, تعليم اونلاين, اونلاين" />
          <meta property="og:title" content="محمد يوسف - رياضيات" />
          <meta
            property="og:description"
            content="تصفح كورسات اونلاين رياضيات المتاحة ثانوية عامة على منصة تعليمية اونلاين رياضيات"
          />
        </Helmet>
        <Container>
          {/* <Home /> */}
          <Suspense fallback={<Col xl={12} className="py-5 mt-5" style={{ minHeight: '4000px' }} aria-hidden="true" />}>
            <MainHome />
          </Suspense>
          <Youtube />
        </Container>
      </Col>
    </>
  );
}
